export default "__VITE_ASSET__C7w_OCxK__"